import { Box, Button } from '@mui/joy';
import { ImageSquare, PencilSimple, Trash, UserPlus } from '@phosphor-icons/react';
import { useState } from 'react';
import ModalRenameGroup from '../GroupModals/ModalRenameGroup';
import ModalAddMembers from '../GroupModals/ModalAddMembers';
import ModalDeleteGroup from '../GroupModals/ModalDeleteGroup';
import ModalGroupChatImage from '../GroupModals/ModalGroupChatImage';

/**
 * Действия над группой на её странице.
 *
 * В шапке чата те же пункты спрятаны в меню на три точки — там нет места. На
 * отдельной странице прятать их незачем: это её основное назначение, и кнопки
 * стоят открыто.
 *
 * Управление показываем только администратору: остальным эти кнопки вернули бы
 * 403, а обещать действие, которое не выполнится, хуже, чем не показывать его.
 */
export default function GroupActions({
    chatId,
    chatName,
    chatImage,
    members = [],
    isAdmin = false,
    onRenamed = () => { },
    onImageUpdated = () => { },
    onMembersUpdated = () => { },
}) {
    const [renameOpen, setRenameOpen] = useState(false);
    const [imageOpen, setImageOpen] = useState(false);
    const [addMembersOpen, setAddMembersOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);

    if (!isAdmin) return null;

    const buttonSx = { borderRadius: '999px', px: 2, py: 1 };

    return (
        <>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center', px: 2 }}>
                <Button
                    variant="soft"
                    color="neutral"
                    startDecorator={<PencilSimple size={16} />}
                    onClick={() => setRenameOpen(true)}
                    sx={buttonSx}
                >
                    Переименовать
                </Button>

                <Button
                    variant="soft"
                    color="neutral"
                    startDecorator={<ImageSquare size={16} />}
                    onClick={() => setImageOpen(true)}
                    sx={buttonSx}
                >
                    Фото группы
                </Button>

                <Button
                    variant="soft"
                    color="neutral"
                    startDecorator={<UserPlus size={16} />}
                    onClick={() => setAddMembersOpen(true)}
                    sx={buttonSx}
                >
                    Добавить
                </Button>

                <Button
                    variant="soft"
                    color="danger"
                    startDecorator={<Trash size={16} />}
                    onClick={() => setDeleteOpen(true)}
                    sx={buttonSx}
                >
                    Удалить группу
                </Button>
            </Box>

            <ModalRenameGroup
                open={renameOpen}
                onClose={() => setRenameOpen(false)}
                chatId={chatId}
                currentName={chatName}
                onRenamed={onRenamed}
            />

            <ModalGroupChatImage
                open={imageOpen}
                onClose={() => setImageOpen(false)}
                chatId={chatId}
                currentImage={chatImage}
                onImageUpdated={onImageUpdated}
            />

            <ModalAddMembers
                open={addMembersOpen}
                onClose={() => setAddMembersOpen(false)}
                chatId={chatId}
                groupMembers={members}
                onMembersUpdated={onMembersUpdated}
            />

            <ModalDeleteGroup
                open={deleteOpen}
                onClose={() => setDeleteOpen(false)}
                chatId={chatId}
            />
        </>
    );
}
